import { Component } from '@angular/core';
import { ButtonModule } from '@progress/kendo-angular-buttons';

@Component({
    selector: 'ntw-user-without-roles',
    templateUrl: './user-without-roles.component.html',
    styleUrls: ['./user-without-roles.component.scss'],
    imports: [ButtonModule]
})
export class UserWithoutRolesComponent {
    public retrying = false;

    public retry(): void {
        this.retrying = true;
        window.location.reload();
    }
}
